import { Box, Grid, SxProps, Theme, Typography } from '@mui/material'
import { ArrowRightCircle } from 'react-feather'
import { Link, useNavigate } from 'react-router-dom'
import { boxContainerStyle, titleStyle } from './GoToBox.styles'

type GoToBoxProps = {
	title: string
	subtitle: string
	to: string
	sx: SxProps<Theme>
	onClick?: () => void
}
export default function GoToBox({ title, subtitle, to, onClick, sx = {} }: GoToBoxProps) {
	return (
		<Box sx={{ width: '100%', ...sx }}>
			<Grid container sx={boxContainerStyle}>
				<Grid item xs={11}>
					<Box>
						<Typography sx={titleStyle}>{title}</Typography>
						<Typography sx={{ lineHeight: '24px', fontSize: '14px' }}>{subtitle}</Typography>
					</Box>
				</Grid>
				<Grid
					item
					xs={1}
					sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' }}
				>
					<Link onClick={onClick} to={to}>
						<ArrowRightCircle />
					</Link>
				</Grid>
			</Grid>
		</Box>
	)
}
